
import type { FinalLoanAssessment, OutcomeData, SetFieldValueCallback } from "./models";

const handleOutcomeParser = (
    applicationId: number,
    userId: number,
    assessmentResult: FinalLoanAssessment,
    setFieldValue: SetFieldValueCallback
) => {
    const outcomeData: OutcomeData = {
        action: "application_processed",
        applicationId: applicationId,
        userId: userId,
        originalSubmission: "",
        processingTimeSeconds: 0,
        processingResults: assessmentResult,
        status: "completed",
        processedAt: new Date().toISOString(),
    };

    setFieldValue("outcome", outcomeData);
    setFieldValue("isLoadingOutcome", false);
};

export default handleOutcomeParser;
